module.exports = __webpack_public_path__ + "static/media/logo-white-vrf.e09169c7.svg";